import { memo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Typography from 'components/UI/Typography/Typography';

import styles from './ProgressSteps.module.scss';

const ProgressSteps = ({ stepsAmount = 0, completedAmount = 0 }) => (
  <div className={styles.root}>
    <Typography type="text-sm" color="grey">
      {completedAmount} of {stepsAmount} activities completed
    </Typography>
    <div
      className={styles.steps}
      style={{
        gridTemplateColumns: `repeat(${stepsAmount}, minmax(30px, 1fr))`,
      }}
    >
      {Array(stepsAmount)
        .fill(null)
        .map((_, index) => (
          <div
            key={index}
            className={classNames(styles.step, {
              [styles.completed]: index < completedAmount,
            })}
          />
        ))}
    </div>
  </div>
);

ProgressSteps.propTypes = {
  stepsAmount: PropTypes.number.isRequired,
  completedAmount: PropTypes.number.isRequired,
};

export default memo(ProgressSteps);
